export default "__VITE_ASSET__6cc827bd__"